import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { serviceFactory } from '@/services';
import { CareSpecialistService } from '@/services/features/CareSpecialistService.ts';

interface CareSpecialistStatusResponse {
  deferred_task: boolean;
  follow_up: boolean;
  care_specialist_id: number;
}

export const useCareSpecialistStatus = () => {
  const { user, hasuraToken } = useAuth();
  const [deferredTask, setDeferredTask] = useState(false);
  const [followUp, setFollowUp] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Get service instance
  const careSpecialistService = serviceFactory.getService(CareSpecialistService);

  useEffect(() => {
    const fetchCareSpecialistStatus = async () => {
      if (!user?.id || !hasuraToken) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        
        const response = await careSpecialistService.fetchCareSpecialistStatus(Number(user.id));

        if (!response.success) {
          throw new Error(response.errors?.[0] || 'Failed to fetch care specialist status');
        }

        const statusData = response.data?.pep_vw_care_specialist_list;
        if (statusData && statusData.length > 0) {
          const csData = statusData[0];
          setDeferredTask(csData.deferred_task || false);
          setFollowUp(csData.follow_up || false);
        }
        
        setError(null);
      } catch (err) {
        console.error('Error fetching care specialist status:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCareSpecialistStatus();
  }, [user?.id, hasuraToken]);

  return { deferredTask, followUp, isLoading, error };
};